module.exports = __webpack_public_path__ + "img/leaf_1.bbc3b90e.png";